<ngx-spinner>
  <img
    src="../assets/img/loader.gif"
    alt=""
    style="width: 250px; height: auto"
  />
</ngx-spinner>

<!-- header -->
<app-header></app-header>

<div class="page-content">
  <router-outlet></router-outlet>
</div>
